import React from 'react';

import classNames from 'classnames';

import {KLARNA_POPUP_LINK, PayOverTimeLocations} from 'constants/payOverTime';

import {useKlarnaMessaging} from 'desktop/hooks/useKlarnaMessaging/useKlarnaMessaging';

import {sendAnalytics} from '../../analytics';

import s from '../buttons.scss';

/**
 * Go to Klarna Pay in 4 or Pay over time
 */
export const KlarnaButton = ({
    amount,
    location,
}: {
    location: PayOverTimeLocations;
    amount: number;
}) => {
    const {klarnaUrl} = useKlarnaMessaging({purchaseAmount: Math.trunc(amount * 100)});
    const link = klarnaUrl || KLARNA_POPUP_LINK;
    const handleClick = () => {
        sendAnalytics(location, 'Klarna');
    };

    return (
        <a
            className={classNames(s.learnMore, s.klarnaLearnMore)}
            href={link}
            onClick={handleClick}
            rel="noreferrer"
            target="_blank"
        >
            Learn more
        </a>
    );
};
